import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import { DetailTestimonialBand } from '~/ui-rocco/pages/detail-shared';

/**
 * The product page's pull quote, on the project: what has been said about
 * the practice behind it, under the hire cards, drawn by the shared band on
 * the page's dark ground.
 */
export const ProjectTestimonialSection = () => {
    const { project } = useLoaderData<typeof loader>();

    return (
        <DetailTestimonialBand
            theme="dark"
            label="Professional Reviews"
            testimonials={project.Professional?.Testimonials ?? []}
        />
    );
};
